import React from 'react'
import hipladeTemplate from '../../common/template'
import FormEventAppraiserFeedback from '../components/FormEventAppraiserFeedback'

function EventAppraiserFeedback() {
  return <FormEventAppraiserFeedback />
}

export default hipladeTemplate(EventAppraiserFeedback)
